import { ADMIN_ROLES } from "../../auth";

import { AppState } from "./model";
import { customerUserSelector } from "./selectors";
import { detailRoutes } from "./detailRoutes";

const detailRoute = () => ({
    "/:customerUserId": {
        title: (state: AppState) => customerUserSelector(state).firstName || "Customer User",
        "/edit": {
            title: "Edit",
        },
        "/myResults/:caseId": {
            title: "My Results"
        },
        "/auditLog": {
            title: "Audit Log",
            authorize: [ADMIN_ROLES.SYSTEM_ADMIN.name],
        },
        ...detailRoutes
    }
});

export const childRoutes =
    (titleFunc: (state: any) => string) => {
        return {
            "/customerUsers": {
                title: (state: AppState) => titleFunc(state) ? titleFunc(state) + " Customer Users" : "Customer Users",
                ...detailRoute(),
                "/create": {
                    title: "Create Customer User",
                }
            }
        };
    };
